import { Component, Input } from '@angular/core';

@Component({
  selector: 'liberro-badge',
  standalone: false,
  templateUrl: './liberro-badge.component.html',
  styleUrl: './liberro-badge.component.less'
})
export class LiberroBadgeComponent {
  @Input() public variant: 'success' | 'danger' | 'default' | 'filter' | 'magenta' | 'exclusive' | 'aquamarine' = 'default';
  @Input() public unbreakable?: boolean = false;
  @Input() public label = '';
}
